const cache = new Map<string, string>();

/**
 * Draws the customer's initial on the default logo background and returns it as a data URL,
 * so no image request is needed. Cached per letter.
 */
export const getLetterLogoDataUrl = (name: string | null | undefined): string => {
	const letter = (name ?? "").trim().charAt(0).toUpperCase();
	const cached = cache.get(letter);
	if (cached !== undefined) {
		return cached;
	}

	const canvas = document.createElement("canvas");
	canvas.width = 130;
	canvas.height = 130;
	const context = canvas.getContext("2d");
	let dataUrl = "";
	if (context) {
		context.fillStyle = "#2e3a59";
		context.fillRect(0, 0, 130, 130);
		context.font = "bold 100px monospace";
		context.textAlign = "center";
		context.fillStyle = "#FFF";
		context.fillText(letter, 65, 130 / 1.3);
		dataUrl = canvas.toDataURL("image/png");
	}

	cache.set(letter, dataUrl);
	return dataUrl;
};
